<script setup>
import CustomSelect from "../components/CustomSelect.vue";
import HauptMenue from "../components/HauptMenue.vue";
import FooterMenu from "../components/FooterMenu.vue";
import DatenschutzHinweis from "../components/DatenschutzHinweis.vue";
import ButtonBack from "../components/ButtonBack.vue";
import { store } from "../components/store.vue";
import Alertbox from "../components/Alertbox.vue";
import AuftraegeSelfService from "../components/AuftraegeSelfService.vue";
/** Komponente zum Einbinden des Menüpunktes mit den Mitarbeiterdaten
 * @displayName Seite Firmen Mitarbeiterdaten
 */
</script>
<script>
export default {
  name: "mitarbeiterdaten",
  components: {
    //myRouter: router,
    CustomSelect,
    HauptMenue,
    FooterMenu,
    DatenschutzHinweis,
    AuftraegeSelfService,
    Alertbox,
  },
  data() {
    return {
      Mitarbeiter: false,
      sAnredeOptions: this.$servertalk.getSelectOpts("ADRANREDE"),
      store,
      inBearbeitung: {
        AenderungPersoenlichedaten: false,
        AenderungBankverbindung: false,
        ErfassungSteuerId: false,
        AenderungKontaktdaten: false,
        AntragBetriebsrente: false,
        AenderungKrankenkasse: false,
        AenderungAnsprechpartnerdaten: false,
        AenderungFirmendaten: false,
        AenderungFirmenAdressdaten: false,
        AenderungFirmenBankdaten: false,
        AenderungFirmenFinanzamtsdaten: false,
        KontaktPensus: false,
        Beitragsfreistellung: false,
        Wiederinkraftsetzung: false,
        Firmenaustritt: false,
        AenderungBeitrag: false,
      },
      unversandt: {
        AenderungPersoenlichedaten: false,
        AenderungBankverbindung: false,
        ErfassungSteuerId: false,
        AenderungKontaktdaten: false,
        AntragBetriebsrente: false,
        AenderungKrankenkasse: false,
        AenderungAnsprechpartnerdaten: false,
        AenderungFirmendaten: false,
        AenderungFirmenAdressdaten: false,
        AenderungFirmenBankdaten: false,
        AenderungFirmenFinanzamtsdaten: false,
        KontaktPensus: false,
        Beitragsfreistellung: false,
        Wiederinkraftsetzung: false,
        Firmenaustritt: false,
        AenderungBeitrag: false,
      },
    };
  },
  methods: {
    chckUnbearbeitet() {
      for (const [key] of Object.entries(this.inBearbeitung)) {
        //console.log("->subData.draft.sService.Entwuerfe." + key);
        this.inBearbeitung[key] =
          this.$servertalk.gettAttr(
            "subData.draft.sService.Entwuerfe." + key
          ) == "modified" ||
          this.$servertalk.gettAttr(
            "masterData.draft.sService.Entwuerfe." + key
          ) == "modified";
        this.unversandt[key] =
          this.$servertalk.checkForUnsentSelfService(key) ||
          this.$servertalk.checkForUnsentSelfService(key, store.subData);
      }
    },
    allowDisplay(Mitarbeiter) {
      // Prüfen, ob Anzeige Versorgungswerte zulässig für Mitarbeiter
      let allowed = false;
      let PMNRs = Mitarbeiter?.Versorgungen?.PMNR ?? false;
      let pmnrArr = [];
      if (PMNRs) {
        //Versorgungen raussuchen und zum Array machen
        pmnrArr = Array.isArray(PMNRs) ? PMNRs : [PMNRs];
        pmnrArr.forEach((p) => {
          if (p.PSELF && p.PSELF == "S") allowed = true;
        });
      }
      return allowed;
    },
  },
  watch: {
    "store.subData.draft.sService.Entwuerfe": {
      handler() {
        this.chckUnbearbeitet();
      },
      deep: true,
    },
    "store.masterData.draft.sService.Entwuerfe": {
      handler() {
        this.chckUnbearbeitet();
      },
      deep: true,
    },
  },
  beforeCreate: function () {
    this.$servertalk.doLog("# Reading From Local, Create ");
    if (!store.auth) {
      //if (!this.$servertalk.restoreStore())
      this.$router.push("/");
    }
    this.$servertalk.doLog("Inhalt store:");
    this.$servertalk.doLog(store);
  },
  mounted: function () {
    window.scrollTo(0, 0);
    this.$servertalk.doLog("# Reading From Local, Mount");
    if (!store.auth) {
      if (!this.$servertalk.restoreStore()) this.$router.push("/");
    }
    window._paq.push(["setDocumentTitle", this.name]);
    window._paq.push(["trackPageView"]);
    this.chckUnbearbeitet();
    // Ermitteln des Index des aktuellen Mitarbeiters in subData
    this.Mitarbeiter = store.xSelectedMitarbeiter;
  },
  computed: {
    getVstatus() {
      // Status aller Versorgungen kommagetrennt liefern
      let pStatus = [];
      let pmnrArr = [];
      let PMNRs = store.xSelectedMitarbeiter?.Versorgungen?.PMNR;
      //es ist ein Array. Alles ok.
      if (Array.isArray(PMNRs)) {
        pmnrArr = PMNRs.map((v) => v);
      } else if (typeof PMNRs === "object") {
        pmnrArr.push(PMNRs);
      }
      pmnrArr.forEach((pmnr) => {
        let t = pmnr?.PSTATUSN_TXT;
        if (!pStatus.includes(t)) {
          pStatus.push(t);
        }
      });
      return pStatus.join(", ");
    },
    getPMNRs() {
      // PMNRs aller Versorgungen kommagetrennt liefern
      let result = [];
      let pmnrArr = [];
      let PMNRs = store.xSelectedMitarbeiter?.Versorgungen?.PMNR;
      //es ist ein Array. Alles ok.
      if (Array.isArray(PMNRs)) {
        pmnrArr = PMNRs.map((v) => v);
      } else if (typeof PMNRs === "object") {
        pmnrArr.push(PMNRs);
      }
      pmnrArr.forEach((pmnr) => {
        let t = pmnr?.PMNR;
        result.push(t);
      });
      return result.join(", ");
    },
    isWartung() {
      let wartung = false;
      let omessage = store.masterData.config?.messages?.Wartung ?? false;
      let now = new Date();
      if (
        omessage &&
        Date.parse(omessage.von) < now &&
        Date.parse(omessage.bis) > now
      ) {
        wartung = true;
      }
      return wartung;
    },
    messageWartung() {
      let message = "";
      if (this.isWartung) {
        message = store.masterData.config?.messages?.Wartung?.message ?? "";
      }
      return message;
    },
    isDbWartung() {
      let wartung = false;
      let omessage = store.masterData.config?.messages?.DBWartung ?? false;
      let now = new Date();
      if (
        omessage &&
        Date.parse(omessage.von) < now &&
        Date.parse(omessage.bis) > now
      ) {
        wartung = true;
      }
      return wartung;
    },
    messageDbWartung() {
      let message = "";
      if (this.isWartung) {
        message = store.masterData.config?.messages?.DBWartung?.message ?? "";
      }
      return message;
    },
  },
};
</script>
<template>
  <main class="main-wrapper schwebend" :class="store.accessRestriction">
    <HauptMenue />
    <div class="mt-36 md:mt-48 lg:mt-56 mb-8 max-w-7xl mx-auto px-5 lg:px-0">
      <h2
        class="text-tertiary font-bold text-l md:text-xl lg:text-2xl text-center uppercase">
        Firma
        <span>
          "{{ store.subData.data.Firmenstammdaten.FNAME }}
          {{
            $servertalk.getName(
              "GESFORM",
              store.subData.data.Firmenstammdaten?.FGESFORM
            )
          }}
          {{ store.subData.data.Firmenstammdaten.FKENNR }}/{{
            store.subData.data.Firmenstammdaten.FABRGR
          }}"
        </span>
      </h2>
      <h1
        class="text-primary/75 font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-12">
        {{ Mitarbeiter.VORNAME }}
        {{ Mitarbeiter.NAME }}
      </h1>
      <div class="kennummer">
        <h3 class="text-xl text-tertiary" v-if="getPMNRs">
          PM-Nr : {{ getPMNRs }}
        </h3>
      </div>
      <div v-if="getVstatus" class="status mb-8">
        <h3 class="text-2xl text-primary">Status: {{ getVstatus }}</h3>
      </div>
      <Alertbox />
      <div
        v-if="isWartung"
        class="p-5 text-primary border border-primary bg-primary/10 rounded-md my-5 max-w-3xl mx-auto">
        {{ messageWartung }}
      </div>
      <div
        v-if="isDbWartung"
        class="p-5 text-primary border border-primary bg-primary/10 rounded-md my-5 max-w-3xl mx-auto">
        {{ messageDbWartung }}
      </div>
      <div
        class="grid gap-5 md:grid-cols-2 xl:grid-cols-3 [&amp;>.item>a>.item-text]:uppercase [&amp;>.item>a>.item-text]:font-bold [&amp;>.item>a>.item-text]:text-center [&amp;>.item>a>.item-text]:px-2 [&amp;>.item>a>.item-text]:text-white [&amp;>.item>a>.item-text]:transition-all [&amp;>.item>a>.item-text]:duration-500 [&amp;>.item>a>.item-text]:py-2 [&amp;>.item>a>.item-image]:border-t [&amp;>.item>a>.item-image]:border-primary">
        <div v-if="allowDisplay(Mitarbeiter)" class="item group relative">
          <RouterLink to="/mitarbeiter-stammdaten">
            <div
              class="item-image relative [&amp;>img]:min-h-[240px] [&amp;>img]:object-cover">
              <img
                src="assets/img/pensus-kontaktdaten-aendern-self-service.webp"
                alt="Mitarbeiterdaten Ändern" />
            </div>
            <div
              class="item-text bg-tertiary/80 group-hover:bg-tertiary absolute bottom-0 w-full">
              Versorgungswerte ansehen
            </div>
          </RouterLink>
        </div>
        <AuftraegeSelfService
          v-bind:nurOffene="false"
          v-bind:fuerMitarbeiter="true"
          v-bind:MitarbeiterID="store.xSelectedMitarbeiter.PERSNR"
          v-model:unversandt="unversandt"
          v-model:inBearbeitung="inBearbeitung" />
      </div>
      <ButtonBack target='/auswahl-mitarbeiter' />
    </div>
  </main>
  <FooterMenu />
</template>
